import React from 'react';
import { CollapsibleDetailsSection } from '../../components';
import { TERMINAL_HARDWARE_DETAILS } from '@shared/data/mockTerminalsPanels';

interface HardwareSectionProps {
  isExpanded: boolean;
  onToggle: () => void;
  isDetailView?: boolean;
  className?: string;
}

export const HardwareSection = React.memo<HardwareSectionProps>(({ isExpanded, onToggle, isDetailView = false, className }) => {
  const handleDiagnose = () => {
    console.log('Diagnose clicked');
    // Add your diagnose logic here
  };

  const actions = [
    {
      label: 'Diagnose',
      onClick: handleDiagnose
    }
  ];

  return (
    <CollapsibleDetailsSection
      title="Hardware"
      details={TERMINAL_HARDWARE_DETAILS}
      isExpanded={isExpanded}
      onToggle={onToggle}
      isDetailView={isDetailView}
      emptyMessage="No hardware details available"
      actions={actions}
      className={className}
    />
  );
});

HardwareSection.displayName = 'HardwareSection';